import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import FormError from '../partials/FormError';
import { saveInspectionProgress, completeInspection } from '../../actions/inspections';
import { resetQuestionsState } from '../../actions/questions';
import { validateCommaEmails } from '../../helpers/validation';
import { destructServerErrors, allErrors } from '../../helpers/error';
import __ from '../../helpers/translation';

const propTypes = {
  inspection: PropTypes.object.isRequired,
};

function GenerateReportModal(props) {

  const dispatch = useDispatch()

  const [sendByMail, setSendByMail] = useState(false);
  const [emails, setEmails] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [errors, setErrors] = useState('');

  useEffect(() => {
    return function cleanup() {
      window.$('.modal-backdrop').remove();
    };
  }, []);

  const generateReport = () => {
    setIsGenerating(true);
    setErrors('');

    dispatch(completeInspection(props.inspection.report.id, emails))
      .then(data => {
        dispatch(resetQuestionsState());
      })
      .catch(error => {
        console.error(error)
        let errors = destructServerErrors(error);
        setErrors(errors ? allErrors(errors).join('') : __('app.questions.generate_report_error'));
        setIsGenerating(false);
      });
  }

  const generateAndSendViaMail = () => {
    if(!emails.length){
      generateReport();
      return;
    }

    if(!validateCommaEmails(emails)){
      setErrors(__('app.questions.send_inspection_input_emails_error'));
      return;
    }

    generateReport();
  }

  const beforeGenerate = () => {
    if(!props.inspection.report.can_send_email){
      generateReport();
      return;
    }

    setSendByMail(true);
  }

  return (
    <div 
      className="modal fade" 
      id="generateReport" 
      tabIndex="-1" 
      role="dialog" 
      aria-labelledby="generateReport" 
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content p-3 p-sm-5">

          {/* Header */}
          <div className="modal-header">
            <h1 className="modal-title fw-600">
              { __('app.questions.generate_report_popup_title') }
            </h1>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          
          {/* Body */}
          <div className="modal-body">

            {errors && ( <FormError>{errors}</FormError> )}

            {sendByMail ? (
              <>
                <p>{__('app.questions.send_inspection_by_mail_message')}</p>
                <div className="form-group">
                  <div className="form-label-group">
                    <input 
                      name="emails" 
                      value={emails} 
                      onChange={(e) => setEmails(e.target.value)} 
                      type="text" 
                      className="form-control" 
                      placeholder={__('app.questions.send_inspection_input_emails')} 
                    />
                    <label htmlFor="emails">
                      {__('app.questions.send_inspection_input_emails')}
                    </label>
                  </div>
                </div>
                <button 
                  onClick={() => generateAndSendViaMail() }
                  disabled={ isGenerating }
                  className="btn btn-success d-block w-100 mt-5"
                >
                  {__('app.questions.send_inspection_button')}
                </button>
              </>
            ) : (
              <>
                <p>{ __('app.questions.generate_report_popup_message')}</p>
                <button 
                  onClick={() => beforeGenerate() }
                  disabled={ isGenerating }
                  className="btn btn-success d-block w-100 mt-5"
                >
                  {__('app.questions.generate_report_popup_button')}
                </button>
              </>
            )}
            
          </div>

        </div>
      </div>
    </div>
  );
}

GenerateReportModal.propTypes = propTypes;

export default GenerateReportModal;